<app-modal-wrapper class="w-full h-full flex-auto"
    [title]="type == 'force' ? 'Actualización Requerida' : 'Actualización Disponible'"
    [showDeleteButton]="false"
    [showMarginBody]="false"
    [triggerCloseService]="false"
    [showFooter]="false"
    [showOkButton]="false"
    (onRequireClose)="later()">

    <ng-container sidebarFormBodyContent>
        <div class="flex flex-col items-center space-y-6">
            <!-- Icono de actualización -->
            <div class="flex items-center justify-center">
                <mat-icon class="text-blue-400" style="font-size: 96px; width: 96px; height: 96px;">
                    system_update
                </mat-icon>
            </div>
            
            <!-- Mensaje -->
            <div class="text-gray-300 text-center" *ngIf="type == 'recommended'">
                Te recomendamos actualizar a una versión más reciente de la aplicación para obtener mejoras y nuevas funcionalidades.
            </div>
            
            <div class="text-gray-300 text-center" *ngIf="type == 'force'">
                Estás usando una versión antigua de la aplicación. Actualiza a la última versión para obtener mejoras y nuevas funcionalidades.
            </div>
            
            <!-- Botones -->
            <div class="flex flex-col gap-4 w-full items-center">
                <!-- Botón Actualizar -->
                <standard-button 
                    class="w-full"
                    (onClick)="update()" 
                    [extendedClass]="'w-full'" 
                    [text]="'Actualizar'">
                </standard-button>
                
                <!-- Link Después (solo si es recomendado) -->
                <a 
                    *ngIf="type == 'recommended'"
                    (click)="later()" 
                    class="text-white text-sm underline font-extralight cursor-pointer hover:text-white/80 transition-colors">
                    Después
                </a>
            </div>
        </div>
    </ng-container>
</app-modal-wrapper>
